import { LibraryPage } from '@/pages/inspection/library/LibraryPage';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/_authenticated/_app/inspection/library/')({
	validateSearch: z.object({
		tab: z.enum(['library', 'tenant']).optional(),
	}),
	component: LibraryPage,
});
